<template>
  <div>
    <div class="is-divider-related-content mb-5" />
    <h3 class="is-size-4 has-text-weight-normal ml-4 is-mobile">
      {{ $t('relatedcontent.text') }}
    </h3>
  
    <ul class="ml-6 list-mobile">
      <li>
        <a
          href="https://www.phila.gov/services/payments-assistance-taxes/debt-collection/resolve-water-liens-judgments/"
          target="_blank"
        >{{ $t('relatedcontent.li1') }}</a>
      </li>
      <li>
        <a
          href="https://www.phila.gov/services/water-gas-utilities/pay-or-dispute-a-water-bill/"
          target="_blank"
        >{{ $t('relatedcontent.li2') }}</a>
      </li>
      <li>
        <a
          href="https://www.phila.gov/services/water-gas-utilities/pay-or-dispute-a-water-bill/water-bill-customer-assistance/"
          target="_blank"
        >{{ $t('relatedcontent.li3') }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "RelatedContent",
};
</script>
<style scoped>
a {
  text-decoration: underline !important;
}

   @media screen and (max-width:767px) {
     .is-divider-related-content {
       margin-left: 0;
       margin-right: 0;
     }

     .is-mobile {
       margin-left: 0 !important;
       margin-right: 0 !important;
     }

     .list-mobile {
       margin-left: 15px !important;
     }
  }


</style>